var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabs = function SvgTabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M19.973 12.945v-.006l-1.741-5.798a1.24 1.24 0 0 0-1.197-.891h-.785a.625.625 0 1 0 0 1.25h.785l1.5 5h-2.441l-1.612-5.36a1.24 1.24 0 0 0-1.197-.89H12.5a.625.625 0 1 0 0 1.25h.785l1.5 5h-2.441l-1.612-5.36a1.24 1.24 0 0 0-1.197-.89H2.97a1.24 1.24 0 0 0-1.201.89l-1.74 5.798v.01a.6.6 0 0 0-.028.177.625.625 0 0 0 .625.625h18.75a.625.625 0 0 0 .598-.805M2.97 7.5h6.57l1.5 5H1.465z"
  })));
};
export default SvgTabs;